<template>
  <div class="relatorio-atividades-unidade">
    <b-card class="shadow mb-4 cabecalho-relatorio">
      <div
        class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center"
      >
        <div>
          <h4 class="mb-1 text-gray-800">Relatório compilado de Atividades</h4>

          <div class="text-muted">
            <strong>{{ unidade.nome || "Carregando unidade..." }}</strong>
          </div>

          <div class="small text-muted mt-1">
            Período:
            <strong>
              {{ datas.start || "--/--/----" }}
              até
              {{ datas.end || "--/--/----" }}
            </strong>
          </div>

          <div class="small text-muted">
            Total de atividades:
            <strong>{{ pagination.total || 0 }}</strong>
          </div>
        </div>

        <div class="mt-3 mt-lg-0 no-print">
          <b-button variant="secondary" class="mr-2" @click="voltar">
            <i class="fas fa-arrow-left mr-1"></i>
            Voltar
          </b-button>

          <b-button variant="primary" @click="print()">
            <i class="fas fa-print mr-1"></i>
            Imprimir página
          </b-button>
        </div>
      </div>
    </b-card>

    <load v-if="loading" />

    <b-alert
      v-else-if="atividades.length === 0"
      show
      variant="info"
      class="shadow-sm"
    >
      <i class="fas fa-info-circle mr-1"></i>

      Nenhuma atividade encontrada para esta unidade no período informado.
    </b-alert>

    <template v-else>
      <print-content>
        <div class="conteudo-impressao">
          <div class="cabecalho-impressao mb-4">
            <h4 class="mb-1">Relatório compilado de Atividades</h4>

            <div>
              Unidade:
              <strong>
                {{ unidade.nome || "Não informada" }}
              </strong>
            </div>

            <div>
              Período:
              <strong>
                {{ datas.start || "--/--/----" }}
                até
                {{ datas.end || "--/--/----" }}
              </strong>
            </div>

            <div>
              Total de atividades:
              <strong>{{ pagination.total || 0 }}</strong>
            </div>

            <div>
              Página:
              <strong>
                {{ pagination.currentPage }}
                de
                {{ pagination.totalPages }}
              </strong>
            </div>
          </div>
          <section
            v-for="atividade in atividades"
            :key="atividade.id"
            class="atividade-compilada bg-white shadow-sm mb-4"
          >
            <div class="atividade-titulo">
              <div>
                <strong>
                  {{ tituloAtividade(atividade) }}
                </strong>
              </div>

              <div>
                <b-badge
                  v-if="atividade.privado"
                  variant="warning"
                  class="mr-2"
                >
                  <i class="fas fa-lock mr-1"></i>
                  Sigiloso
                </b-badge>

                <span class="text-muted"> #{{ atividade.id }} </span>
              </div>
            </div>

            <div class="table-responsive">
              <table
                class="table table-bordered table-sm mb-0 tabela-detalhes-atividade"
              >
                <tbody>
                  <tr>
                    <td>
                      ID:
                      <strong>{{ atividade.id }}</strong>
                    </td>

                    <td>
                      PROTOCOLO:
                      <strong>{{ atividade.protocolo }}</strong>
                    </td>

                    <td>
                      CADASTRADO:
                      <strong>
                        {{ atividade.created_at || "Não informado" }}
                      </strong>
                    </td>

                    <td>
                      ATUALIZADO:
                      <strong>
                        {{ atividade.updated_at || "Não informado" }}
                      </strong>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="2">
                      TÉCNICO RESPONSÁVEL:

                      <strong v-if="atividade.responsavel">
                        {{ atividade.responsavel.nome }}
                      </strong>

                      <span v-else class="text-muted"> Não informado </span>

                      <b-badge
                        v-if="
                          atividade.responsavel &&
                          atividade.responsavel.profissao
                        "
                        variant="light"
                        class="ml-1"
                      >
                        {{ atividade.responsavel.profissao }}
                      </b-badge>
                    </td>

                    <td>
                      TÉCNICO AUTOR:

                      <strong v-if="atividade.autor">
                        {{ atividade.autor.nome }}
                      </strong>

                      <span v-else class="text-muted"> Não informado </span>
                    </td>

                    <td>
                      UNIDADE:
                      <strong>{{ atividade.unidade.nome }}</strong>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="4">
                      TÍTULO:

                      <strong v-if="atividade.titulo">
                        {{ atividade.titulo }}
                      </strong>

                      <span v-else class="text-muted"> Não informado </span>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="2">
                      TIPO:
                      <strong>{{ atividade.tipo }}</strong>
                    </td>

                    <td colspan="2">
                      STATUS:

                      <strong
                        :style="{
                          color: atividade.status.cor || '#343a40',
                        }"
                      >
                        {{ atividade.status.descricao }}
                      </strong>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="2">
                      DATA:

                      <strong>
                        {{ atividade.data || "Não informado" }}
                      </strong>
                    </td>

                    <td>
                      HORA:

                      <strong>
                        {{ atividade.hora || "Não informado" }}
                      </strong>
                    </td>

                    <td>
                      DURAÇÃO:

                      <strong>
                        {{ atividade.duracao || "Não informado" }}
                      </strong>
                    </td>
                  </tr>

                  <tr v-if="atividade.local">
                    <td colspan="4">
                      LOCAL:
                      <strong>{{ atividade.local }}</strong>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="4">
                      <div class="campo-label">OBSERVAÇÃO / CONTEÚDO:</div>

                      <div
                        v-if="atividade.conteudo"
                        class="campo-html"
                        v-html="atividade.conteudo"
                      ></div>

                      <span v-else class="text-muted"> Não informado </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="participantes-container">
              <div class="campo-label mb-2">TÉCNICOS PARTICIPANTES:</div>

              <div
                v-if="atividade.participantes.length > 0"
                class="table-responsive"
              >
                <table class="table table-bordered table-sm mb-0">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th class="coluna-situacao">Situação</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="participante in atividade.participantes"
                      :key="atividade.id + '-participante-' + participante.id"
                    >
                      <td>
                        {{ participante.nome }}
                      </td>

                      <td>
                        <b-badge
                          :variant="
                            varianteSituacaoParticipante(
                              atividade,
                              participante.id
                            )
                          "
                        >
                          {{ situacaoParticipante(atividade, participante.id) }}
                        </b-badge>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <span v-else class="t\ext-muted">
                Nenhum participante informado.
              </span>
            </div>

            <div
              v-if="
                atividade.usuarios_vinculados &&
                atividade.usuarios_vinculados.length > 0
              "
              class="participantes-container usuarios-vinculados"
            >
              <div
                class="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3"
              >
                <div class="campo-label mb-2 mb-md-0">
                  USUÁRIOS VINCULADOS À ATIVIDADE:
                </div>

                <div
                  v-if="atividade.resumo_usuarios_vinculados"
                  class="resumo-presencas"
                >
                  <b-badge variant="primary" class="mr-1 px-2 py-1">
                    Total:
                    {{ atividade.resumo_usuarios_vinculados.total }}
                  </b-badge>

                  <b-badge variant="success" class="mr-1 px-2 py-1">
                    Presentes:
                    {{ atividade.resumo_usuarios_vinculados.presentes }}
                  </b-badge>

                  <b-badge variant="danger" class="px-2 py-1">
                    Ausentes:
                    {{ atividade.resumo_usuarios_vinculados.ausentes }}
                  </b-badge>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table table-bordered table-sm mb-0">
                  <thead>
                    <tr>
                      <th>Nome</th>

                      <th class="coluna-presenca text-center">Presença</th>

                      <th class="coluna-vinculo text-center">Vínculo</th>

                      <th class="coluna-assinatura">Assinatura</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="usuario in atividade.usuarios_vinculados"
                      :key="
                        atividade.id +
                        '-usuario-vinculado-' +
                        usuario.vinculo_id
                      "
                    >
                      <td>
                        {{ usuario.nome }}
                      </td>

                      <td class="text-center">
                        <b-badge
                          :variant="usuario.presenca ? 'success' : 'danger'"
                        >
                          {{ usuario.presenca ? "Presente" : "Ausente" }}
                        </b-badge>
                      </td>

                      <td class="text-center">
                        <b-badge
                          :variant="
                            usuario.status === 1 ? 'primary' : 'secondary'
                          "
                        >
                          {{ usuario.status_descricao }}
                        </b-badge>
                      </td>

                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div
              v-if="atividade.outros_participantes.length > 0"
              class="secao-atividade"
            >
              <div class="campo-label">OUTROS PARTICIPANTES:</div>

              <ul class="mb-0 pl-4">
                <li
                  v-for="(
                    participante, index
                  ) in atividade.outros_participantes"
                  :key="atividade.id + '-outro-participante-' + index"
                >
                  {{ participante }}
                </li>
              </ul>
            </div>

            <div
              v-if="atividade.qtde_sem_printuario !== null"
              class="secao-atividade"
            >
              <div class="campo-label">USUÁRIOS SEM PRONTUÁRIO:</div>

              <strong>
                {{ atividade.qtde_sem_printuario }}
              </strong>
            </div>

            <div v-if="atividade.tema" class="secao-atividade">
              <div class="campo-label">TEMA:</div>

              <div>{{ atividade.tema }}</div>
            </div>

            <div v-if="atividade.objetivo_especifico" class="secao-atividade">
              <div class="campo-label">OBJETIVO ESPECÍFICO:</div>

              <div
                class="campo-html"
                v-html="atividade.objetivo_especifico"
              ></div>
            </div>

            <div v-if="atividade.dinamica" class="secao-atividade">
              <div class="campo-label">
                DINÂMICA/SÍNTESE DE DESENVOLVIMENTO:
              </div>

              <div class="campo-html" v-html="atividade.dinamica"></div>
            </div>

            <div v-if="atividade.materiais_utilizados" class="secao-atividade">
              <div class="campo-label">MATERIAIS A SEREM UTILIZADOS:</div>

              <div
                class="campo-html"
                v-html="atividade.materiais_utilizados"
              ></div>
            </div>
          </section>
        </div>
      </print-content>

      <b-card class="shadow-sm no-print">
        <div
          class="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <b-pagination
              v-model="page"
              :total-rows="pagination.total"
              :per-page="perPage"
              :disabled="loading"
              :limit="7"
              class="mb-0"
              @change="changePage"
            />

            <b-form-select
              v-model="perPage"
              :options="perPageOptions"
              :disabled="loading"
              class="ml-3"
              style="width: 90px"
              @change="changePerPage"
            />
          </div>

          <div class="mt-3 mt-lg-0 text-muted">
            Página
            <strong>{{ pagination.currentPage }}</strong>
            de
            <strong>{{ pagination.totalPages }}</strong>

            — Total de
            <strong>{{ pagination.total }}</strong>
            atividades
          </div>
        </div>
      </b-card>
    </template>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "AtividadesUnidade",

  data() {
    return {
      loading: false,

      atividades: [],

      unidade: {
        id: null,
        nome: "",
        tipo: null,
        subtipo: null,
      },

      datas: {
        start: "",
        end: "",
        start_iso: "",
        end_iso: "",
      },

      page: Number(this.$route.query.page) || 1,
      perPage: Number(this.$route.query.perPage) || 10,

      perPageOptions: [
        {
          value: 5,
          text: "5",
        },
        {
          value: 10,
          text: "10",
        },
        {
          value: 25,
          text: "25",
        },
        {
          value: 50,
          text: "50",
        },
        {
          value: 100,
          text: "100",
        },
      ],

      dataInicio:
        this.$route.query.data_inicio ||
        moment().subtract(1, "year").format("YYYY-MM-DD"),

      dataFim: this.$route.query.data_fim || moment().format("YYYY-MM-DD"),

      pagination: {
        currentPage: 0,
        perPage: 10,
        total: 0,
        totalPages: 0,
      },
    };
  },

  mounted() {
    this.carregarAtividades();
  },

  methods: {
    carregarAtividades() {
      this.loading = true;

      const unidadeId = this.$route.params.unidadeId;

      axios
        .get(
          `api/dashboard/report/atividades/unidades/${unidadeId}/compilado`,
          {
            params: {
              data_inicio: this.dataInicio,
              data_fim: this.dataFim,
              page: this.page,
              perPage: this.perPage,
            },
          }
        )
        .then((response) => {
          this.unidade = response.data.unidade || {};
          this.datas = response.data.datas || {};
          this.atividades = response.data.dados || [];

          this.pagination = response.data.pagination || {
            currentPage: 0,
            perPage: this.perPage,
            total: 0,
            totalPages: 0,
          };

          this.page = this.pagination.currentPage || this.page;

          this.atualizarQuery();
        })
        .catch((error) => {
          let mensagem = "";

          /*
           * O interceptor pode rejeitar a requisição diretamente
           * com uma string.
           */
          if (typeof error === "string") {
            mensagem = error;
          }

          /*
           * Erro JavaScript convencional.
           */
          if (!mensagem && error && error.message) {
            mensagem = error.message;
          }

          /*
           * Resposta convencional do Axios.
           */
          if (!mensagem && error && error.response && error.response.data) {
            if (typeof error.response.data === "string") {
              mensagem = error.response.data;
            } else if (error.response.data.message) {
              mensagem = error.response.data.message;
            } else if (
              error.response.data.error &&
              typeof error.response.data.error === "string"
            ) {
              mensagem = error.response.data.error;
            }
          }

          const mensagemAcessoNegado =
            "Somente gestores e coordenadores podem acessar este relatório.";

          const acessoNegado =
            mensagem === mensagemAcessoNegado ||
            mensagem.includes("Somente gestores e coordenadores") ||
            (error && error.response && error.response.status === 403);

          if (acessoNegado) {
            swal
              .fire({
                title: "Acesso Negado",
                text: mensagem || mensagemAcessoNegado,
                icon: "error",
                confirmButtonText: "Voltar",
                allowOutsideClick: false,
                allowEscapeKey: false,
              })
              .then(() => {
                this.$router.push("/dashboard/relatorios/atividades/home");
              });

            return;
          }

          if (error && error.response && error.response.status === 404) {
            swal.fire({
              title: "Ops!",
              text: "A unidade informada não foi encontrada.",
              icon: "error",
            });

            return;
          }

          if (error && error.response && error.response.status === 422) {
            swal.fire({
              title: "Dados inválidos",
              text: mensagem || "Verifique o período informado.",
              icon: "warning",
            });

            return;
          }

          swal.fire({
            title: "Ops!",
            text:
              mensagem || "Não foi possível carregar as atividades da unidade.",
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    changePage(page) {
      if (page < 1 || page === this.pagination.currentPage) {
        return;
      }

      this.page = page;
      this.carregarAtividades();
      window.scrollTo(0, 0);
    },

    changePerPage() {
      this.page = 1;
      this.carregarAtividades();
      window.scrollTo(0, 0);
    },

    atualizarQuery() {
      const query = {
        data_inicio: this.dataInicio,
        data_fim: this.dataFim,
        page: this.page,
        perPage: this.perPage,
      };

      this.$router
        .replace({
          name: this.$route.name,
          params: {
            unidadeId: this.$route.params.unidadeId,
          },
          query,
        })
        .catch(() => {});
    },

    voltar() {
      this.$router.push({
        name: "relatorios_home_atividades",

        query: {
          data_inicio: this.dataInicio,
          data_fim: this.dataFim,
        },
      });
    },

    imprimir() {
      window.print();
    },

    tituloAtividade(atividade) {
      if (atividade.titulo) {
        return atividade.titulo;
      }

      if (atividade.tema) {
        return atividade.tema;
      }

      return "Atividade #" + atividade.id;
    },

    possuiParticipante(lista, participanteId) {
      return (lista || []).some((participante) => {
        return Number(participante.id) === Number(participanteId);
      });
    },

    situacaoParticipante(atividade, participanteId) {
      if (
        this.possuiParticipante(
          atividade.participantes_presentes,
          participanteId
        )
      ) {
        return "Presente";
      }

      if (
        this.possuiParticipante(
          atividade.participantes_ausentes,
          participanteId
        )
      ) {
        return "Ausente";
      }

      return "Não confirmada";
    },

    varianteSituacaoParticipante(atividade, participanteId) {
      const situacao = this.situacaoParticipante(atividade, participanteId);

      if (situacao === "Presente") {
        return "success";
      }

      if (situacao === "Ausente") {
        return "danger";
      }

      return "secondary";
    },
  },
};
</script>

<style scoped>
.usuarios-vinculados {
  background: #fcfcfd;
}

.resumo-presencas {
  white-space: nowrap;
}

.coluna-presenca {
  width: 130px;
}

.coluna-vinculo {
  width: 130px;
}

.coluna-assinatura {
  width: 230px;
}

@media (max-width: 767px) {
  .resumo-presencas {
    white-space: normal;
  }

  .coluna-presenca,
  .coluna-vinculo,
  .coluna-assinatura {
    width: auto;
  }
}

.relatorio-atividades-unidade {
  position: relative;
}

.cabecalho-relatorio {
  border-left: 4px solid #4e73df;
}

.atividade-compilada {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  overflow: hidden;
}

.atividade-titulo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  background: #f8f9fc;
  border-bottom: 1px solid #dee2e6;
  font-size: 16px;
}

.tabela-detalhes-atividade td {
  vertical-align: top;
  padding: 10px;
}

.participantes-container {
  padding: 16px;
  border-top: 1px solid #dee2e6;
}

.secao-atividade {
  padding: 14px 16px;
  border-top: 1px solid #dee2e6;
}

.campo-label {
  font-weight: 600;
  margin-bottom: 5px;
}

.campo-html {
  overflow-wrap: anywhere;
}

.campo-html > :last-child {
  margin-bottom: 0;
}

.coluna-situacao {
  width: 180px;
}

@media (max-width: 767px) {
  .atividade-titulo {
    align-items: flex-start;
    flex-direction: column;
  }

  .atividade-titulo > div:last-child {
    margin-top: 8px;
  }

  .coluna-situacao {
    width: auto;
  }
}

@media print {
  .no-print {
    display: none !important;
  }

  .relatorio-atividades-unidade {
    font-size: 11px;
  }

  .cabecalho-relatorio,
  .atividade-compilada {
    box-shadow: none !important;
  }

  .atividade-compilada {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .atividade-titulo {
    background: #ffffff !important;
  }
}
</style>
